// Which controls the slim alert row shows, given the alert.
//
// Separated from the component because this is where its substance is: almost every element in
// `shortlist.slim.header.dropdown.tpl.html` is behind an `ng-if`, and the row a user sees is
// entirely decided by what KIND of alert is loaded. This repo tests decisions and gates pixels
// with the visual diff, so the decisions live somewhere a test can reach without a DOM.
//
// Transcribed from the template:
//
//   pen          ng-if="!alert.hostSite && !alert.extensionJobId"
//   actions ☰    ng-if="!alert.hostSite"
//   save CTA     ng-if="!!alert.hostSite"
//   footer       ng-if="!!alert.hostSite"
//   logo         ng-if="isCompanySearch && !!alert.metadata.companyLogoUrl"

/** The parts of `IEntityAlertDTO` this row reads (entity-hunters-container-base.ng1.ts:92). */
export interface SlimHeaderAlert {
  id: number
  name: string
  /** A saved search imported from LinkedIn, Indeed, CV-Library, Monster or Reed. */
  hostSite?: string | null
  /** Set when the alert is bound to an ATS job, which then owns its criteria. */
  extensionJobId?: number | null
  metadata?: { companyLogoUrl?: string | null } | null
}

export interface SlimHeaderControls {
  /** A saved search imported from a job board, rather than one built in Woo. */
  isHostSearch: boolean
  showsEdit: boolean
  showsActions: boolean
  showsSaveCta: boolean
  showsLogo: boolean
}

/**
 * ⚠️ `!!` ON A STRING, NOT `!== undefined`. Upstream's conditions are AngularJS truthiness, so
 * an empty `hostSite` is falsy there and the alert is an ordinary one. A null check alone would
 * treat `hostSite: ''` as an imported search and swap the edit pen for a save CTA that posts
 * nowhere — the kind of divergence that only appears against real data.
 */
export function slimHeaderControls(alert: SlimHeaderAlert, isCompanySearch = false): SlimHeaderControls {
  const isHostSearch = typeof alert.hostSite === 'string' && alert.hostSite.length > 0
  const boundToJob = alert.extensionJobId !== undefined && alert.extensionJobId !== null
  const logoUrl = alert.metadata?.companyLogoUrl
  return {
    isHostSearch,
    // The pen is hidden for BOTH: an imported search has no Woo criteria to edit, and a
    // job-bound alert's criteria belong to the job.
    showsEdit: !isHostSearch && !boundToJob,
    showsActions: !isHostSearch,
    showsSaveCta: isHostSearch,
    showsLogo: isCompanySearch && typeof logoUrl === 'string' && logoUrl.length > 0,
  }
}
